import {Component, OnInit, EventEmitter } from '@angular/core';
import {Router, Params, ActivatedRoute} from '@angular/router';
import {Notification} from './notification';
import {NotificationsService} from './notifications.service';

@Component({
    selector: 'notifications',
    template: require('./notifications.component.html'),
    providers: [NotificationsService]
})

export class SuperUserNotificationsComponent implements OnInit {

    notifications: Notification[];    
    notificationSelected: number;

    constructor(private _notificationsService: NotificationsService, private route: ActivatedRoute) {
        this.notificationSelected = Number(route.snapshot.params['notificationId']);
    }

    ngOnInit() {

       this._notificationsService.getNotifications().then(res => {

           if (res != null) {               
               this.notifications = res;

               this.setNotificationsDateFormat();

           }

       });

    }

    setNotificationsDateFormat() {

        for (var i = 0; i < this.notifications.length; i++) {

            var date: string;
            date = this.notifications[i].creation_date;
            date = date.substr(0,10);
            date = date.substr(8,2) + "/" + date.substr(5,2) + "/" + date.substr(0,4);
            this.notifications[i].creation_date = date;

        }

    }

    notificationSelect(notification: Notification) {
        if(notification.id!=this.notificationSelected)
            this.notificationSelected=notification.id;
        else 
            this.notificationSelected=0;
    }

    isSelected(notification: Notification): boolean {
        return notification.id==this.notificationSelected;
    }

    getColor(notification: Notification) {

        if (notification.id==this.notificationSelected) {

            return "#97D685";

        } else {

            return "white";

        }

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/notifications/notifications.component.ts
 **/